import { Reducer } from 'redux';

import { ISetBlacklist, IBlacklist, IUnblacklist, TBlacklist } from '../actions';
import { Blacklist } from '../entities';

export type IBlacklistState = Blacklist[];
export const defaultBlacklistState = [];

export const blacklistReducer: Reducer<IBlacklistState> = (
  state: IBlacklistState = defaultBlacklistState,
  action: ISetBlacklist | IBlacklist | IUnblacklist
): IBlacklistState => {
  switch (action.type) {
    case TBlacklist.SET_BLACKLIST:
      return action.payload;
    case TBlacklist.BLACKLIST:
      return [...state, action.payload];
    case TBlacklist.UNBLACKLIST:
      return state.filter(({ media }) => media.id !== action.payload);
  }
  return state;
};

